export const RECENT_SEARCH_LIST_LIMIT = 5;
export const croppingRatio = 6;
export const outputQuality = 90;
export const outputInterpolation = 'progressive-bilinear';
export const SURCHARGE_ORDINANCE_CODE = 'surchargeOrdinanceCostDescription';
export const RESORT_FEE_CODE = 'resortFeeDescription';
export const DESTINATION_FEE_CODE = 'destinationFeeDescription';
export const MANDATORYFEE_TITLE = 'Surcharge For Ordinance Cost';
export const DAILY_TEXT = 'Daily ';
export const FEEDESCRIPTION2 = 'Surcharge for Ordinance Cost';
export const FEEDESCRIPTION_RESORT = 'Resort Fee';
export const FEEDESCRIPTION_DESTINATION = 'Destination Amenity Fee';
export const VIEW_RATE_LABEL = 'View Rates';
export const PARAM_PAGENO = 'pg';
export const INCLUDES_LABEL = 'Includes';
export const RESORT_LABEL = 'Resort';
export const FEE_LABEL = 'fee';
export const DAILY_LABEL = 'daily';
export const DAILY_RESORT_FEE_LABEL = 'Daily Resort Fee';
export const DAILY_DESTINATION_FEE_LABEL = 'Daily Destination Amenity Fee';
export const DAILY_TOURISM_MARKETING_FEE_LABEL = 'Daily Tourism Marketing Fee';
export const SURCHARGE_MANDATORY_FEE_LABEL = 'Surcharge for Ordinance Cost';
export const DESTINATION_AMENITY_LABEL = 'Destination Amenity';
export const HOTEL_MARKETING_CAPTION = 'HOTEL_MARKETING_CAPTION';
export const RESORT_FEE_DESCRIPTION = 'RESORT_FEE_DESCRIPTION';
export const SURCHARGE_ORDINANCE_COST_DESCRIPTION = 'SURCHARGE_ORDINANCE_COST_DESCRIPTION';
export const DESTINATION_FEE_DESCRIPTION = 'DESTINATION_FEE_DESCRIPTION';
export const TOURISM_MARKETING_FEE_DESCRIPTION = 'TOURISM_MARKETING_FEE_DESCRIPTION';
